// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

import { useLocation } from 'react-router-dom';

function DetalleProducto() {
    const location = useLocation();
    const producto = location.state?.producto;

    const addLineBreak = (str) =>
        str.split('\n').map((subStr, index) => {
          if(subStr.includes("#B")){
            return (
              <MKTypography style={{ marginTop: "20px", marginBottom: "20px" }} component="h3" fontWeight="bold" key={index}>
                {subStr.replace("#B", "")}
              </MKTypography>
            );
          } else {
            return (
                <p key={index}>
                    {subStr}
                </p>
            );
          }
    });

    const addLineBreakList = (str) => {
        return (
            <ul>
                {
                    str.split('\n').map((subStr, index) => {
                        if(subStr.length > 0)
                        return (
                            <li key={index}>
                                {subStr}
                            </li>
                        );
                    })
                }
            </ul>
        )
    };
    
  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox minHeight="30vh"></MKBox>
      <Card
        minHeight="30vh"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                {producto.titulo}
              </MKTypography>
              <MKTypography variant="h3" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                {producto.titulo2}
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <MKBox component="section">
            <Container>
                <Grid container
                    item
                    flexDirection="column"
                    sx={{ textAlign: "justify", mx: "auto", px: 0.75 }}
                >
                    <Grid item xs={12} lg={12}>
                        <MKBox
                            component="img"
                            src={producto.imagen}
                            alt="producto"
                            my="auto"
                            opacity={1}
                            style={{display: "flex"}}
                            sx={{
                                maxWidth: '100%',
                                height: 'auto',
                                display: 'block',
                                margin: '0 auto'
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="body1" color="text">
                {addLineBreak(producto.descripcion)}
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", mx: "auto", px: 0.75 }}
            >
                <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                    Fabricación
                </MKTypography>
                <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                    {addLineBreak(producto.fabricacion)}
                </MKTypography>
                <Grid item xs={12} lg={12}>
                    <MKBox
                        component="img"
                        src={producto.fabricacion_imagen}
                        alt="producto"
                        my="auto"
                        opacity={1}
                        sx={{
                            maxWidth: '100%',   // Nunca se sale del contenedor
                            height: 'auto',     // Mantiene la proporción
                            display: 'block',   // Quita espacio inferior
                            margin: '0 auto'    // La centra si el contenedor es más ancho
                        }}
                    />
                </Grid>
            </Grid>
          </Container>
        </MKBox>
        {
            producto.cuerpo ? (
                <MKBox
                    component="section"
                    variant="gradient"
                    bgColor="dark"
                    position="relative"
                    py={6}
                    px={{ xs: 2, lg: 0 }}
                    mx={-2}
                    style={{marginTop: "40px", marginBottom: "40px"}}
                >
                    <Container>
                        <Grid container>
                            <Grid item xs={12} lg={6} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                <MKTypography variant="h1" fontWeight="bold" color="#FFFFFF" style={{marginBottom: "30px"}}>
                                    Cuerpo
                                </MKTypography>
                                <MKTypography variant="body1" color="#FFFFFF" style={{marginBottom: "20px"}}>
                                    {addLineBreakList(producto.cuerpo)}
                                </MKTypography>
                            </Grid>
                            <Grid item xs={12} lg={6} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                <MKTypography variant="h1" fontWeight="bold" color="#FFFFFF" style={{marginBottom: "30px"}}>
                                    Partes Internas
                                </MKTypography>
                                <MKTypography variant="body1" color="#FFFFFF" style={{marginBottom: "20px"}}>
                                    {addLineBreakList(producto.partes_internas)}
                                </MKTypography>
                            </Grid>
                        </Grid>
                    </Container>
                </MKBox>
            ) : null
        }
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", mx: "auto", px: 0.75 }}
            >
                <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{marginBottom: "30px", marginTop: "40px"}} align='center'>
                    Aplicaciones
                </MKTypography>
                <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                    {addLineBreak(producto.aplicaciones)}
                </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <MKBox component="section" style={{marginBottom: "30px"}}>
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              sx={{ textAlign: "justify", mx: "auto", px: 0.75 }}
            >
                <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{marginBottom: "30px"}} align='center'>
                    Marcas
                </MKTypography>
                <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                    {addLineBreak(producto.marcas)}
                </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        </Card>
        <MKBox pt={6} px={1} mt={6}>
            <DefaultFooter content={footerRoutes} />
        </MKBox>
    </>
  );
}

export default DetalleProducto;
